import type { Plugin } from 'vite'

interface XzxConfig {
  iconUrl?: string
  [key: string]: any
}

const XzxVitePlugin = (option: XzxConfig = {}): Plugin => {
  const defaultOption = {}
  const options = { ...defaultOption, ...option }
  return {
    name: 'xzx-vite-plugin',
    config() {
      return {
        define: {
          __XZX_ICON_URL__: JSON.stringify(options?.iconUrl), // 定义环境变量
        },
      }
    },
  } as Plugin
}

export { XzxVitePlugin }
